import { types } from 'mobx-state-tree';

export type TCompatibleBikeModel = typeof CompatibleBikeModel.Type;

export const CompatibleBikeModel = types.model('CompatibleBikeModel', {
    color: types.maybeNull(types.string),
    id: types.string,
    model: types.maybeNull(types.string),
    serie: types.maybeNull(types.string),
});
